<!-- Hero Start -->
<section class="bg-half-170 bg-light d-table w-100" id="home">
    <div class="container">
        <div class="row mt-5 justify-content-center">
            <div class="col-lg-12 text-center">
                <div class="pages-heading">
                    <h4 class="title mb-0"> Box Shadows </h4>
                </div>
            </div> <!--end col-->
        </div><!--end row-->

        <div class="position-breadcrumb">
            <nav aria-label="breadcrumb" class="d-inline-block">
                <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                    <li class="breadcrumb-item"><a routerLink="/index">Landrick</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Components</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Shadows</li>
                </ul>
            </nav>
        </div>
    </div> <!--end container-->
</section><!--end section-->
<!-- Hero End -->

<!-- Shape Start -->
<div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!--Shape End-->

<section class="section">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-4 d-md-block d-none">
                <app-component-sidebar></app-component-sidebar>
            </div>

            <div class="col-lg-9 col-md-8 col-12">
                <div class="row">
                    <!-- Card Start -->
                    <div class="col">
                        <div class="component-wrapper rounded shadow">
                            <div class="p-4 border-bottom">
                                <h5 class="title mb-0"> Box Shadows </h5>
                            </div>

                            <div class="p-4">
                                <h6 class="text-muted mb-2 pb-2">Ex. 
                                    <pre><code class="text-danger">
&lt;div class="shadow-none p-3 mb-5 bg-light rounded">No shadow&lt;/div&gt;
&lt;div class="shadow-sm p-3 mb-5 bg-body rounded"&gt;shadow-sm&lt;/div&gt;
&lt;div class="shadow p-3 mb-5 bg-body rounded"&gt;shadow&lt;/div&gt;
&lt;div class="shadow-md p-3 mb-5 bg-body rounded"&gt;shadow-md&lt;/div&gt;
&lt;div class="shadow-lg p-3 mb-5 bg-body rounded"&gt;shadow-lg&lt;/div&gt;
</code></pre>
                                </h6>

                                <div class="shadow-none p-3 mb-5 bg-light rounded">No shadow</div>
                                <div class="shadow-sm p-3 mb-5 bg-body rounded">shadow-sm</div>
                                <div class="shadow p-3 mb-5 bg-body rounded">shadow</div>
                                <div class="shadow-md p-3 mb-5 bg-body rounded">shadow-md</div>
                                <div class="shadow-lg p-3 mb-5 bg-body rounded">shadow-lg</div>
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end col-->
        </div>
    </div>
</section>

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>
  <!-- Back to top -->
